var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Close } from '@mui/icons-material';
import { Typography } from '@mui/material';
import React from 'react';
import { DynamicFormBuilderContainer } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
var ViewJobItems = function (_ref) {
    var onClose = _ref.onClose, data = _ref.data;
    // const jobCard = useParams()
    // const dispatch = useAppDispatch()
    var elements = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            sx: {
                padding: '12px',
                bgcolor: 'background.secondary',
                borderRadius: 2,
                rowGap: 2,
                columnGap: '12px'
            },
            // hidden only UAT v2.5
            // elements: [
            //     {
            //         type: FormItemTypes.SearchSelect,
            //         name: 'ObservationId',
            //         label: 'Observation',
            //         value: null,
            //         columnSize: 12,
            //         getListData: complaintTypeObservationAPICall,
            //         apiKey: 'ComplaintsObservationList',
            //         displayExpr: 'ComplaintName',
            //         valueExpr: 'ComplaintId'
            //     },
            //     {
            //         type: FormItemTypes.SearchSelect,
            //         name: 'ActionTakenId',
            //         label: 'Action taken',
            //         value: null,
            //         columnSize: 12,
            //         getListData: complaintTypeActionTakenAPICall,
            //         apiKey: 'actionTakenList',
            //         valueExpr: 'ComplaintId',
            //         displayExpr: "ComplaintName",
            //     },
            //     {
            //         type: FormItemTypes.TextInput,
            //         name: 'ServiceAdvisorSuggestions',
            //         label: 'SA suggestion',
            //         value: null,
            //         columnSize: 12
            //     },
            //     {
            //         type: FormItemTypes.TextInput,
            //         name: 'CustomerAdditionalRemarks',
            //         label: 'Customer Remark',
            //         value: null,
            //         columnSize: 12
            //     },
            //     {
            //         type: FormItemTypes.SearchSelect,
            //         name: 'CVType',
            //         label: 'CV type',
            //         value: null,
            //         columnSize: 12,
            //         getListData: CustomerVoiceCVTypeListAPICall,
            //         apiKey: 'customerVoiceCVTypeList',
            //         valueExpr: 'id',
            //         displayExpr: 'DisplayName'
            //     },
            //     {
            //         type: FormItemTypes.TextInput,
            //         name: 'PDIInspectionComments',
            //         label: 'PDI inspection',
            //         value: null,
            //         columnSize: 12
            //     },
            //     {
            //         type: FormItemTypes.SearchSelect,
            //         name: 'SubCategoryId',
            //         label: 'Sub category',
            //         value: null,
            //         columnSize: 12,
            //         getListData: complaintSubCategoryAPICall,
            //         apiKey: 'subCategory',
            //         apiRequest: { JobCardId: jobCard?.id },
            //         displayExpr: 'DisplayName',
            //         valueExpr: 'id'
            //     },
            //     {
            //         type: FormItemTypes.TextInput,
            //         name: 'CustomerVoiceName',
            //         label: 'Customer voice from',
            //         value: null,
            //         columnSize: 12
            //     },
            //     {
            //         type: FormItemTypes.TextInput,
            //         name: 'Remarks',
            //         label: 'SA overall remark',
            //         value: null,
            //         columnSize: 12
            //     },
            //     {
            //         type: FormItemTypes.TextInput,
            //         name: 'FIstatus',
            //         label: 'FI status',
            //         value: null,
            //         columnSize: 12,
            //         disabled: true
            //     },
            //     {
            //         type: FormItemTypes.TextInput,
            //         name: 'FI remark',
            //         label: 'FI remark',
            //         value: null,
            //         columnSize: 12,
            //         disabled: true
            //     },
            //     {
            //         type: FormItemTypes.TextInput,
            //         name: 'FIreason',
            //         label: 'FI reason',
            //         value: null,
            //         columnSize: 12,
            //         disabled: true
            //     },
            //     {
            //         type: FormItemTypes.TextInput,
            //         name: 'Rework',
            //         label: 'Rework',
            //         value: null,
            //         columnSize: 12,
            //         disabled: true
            //     },
            //     {
            //         type: FormItemTypes.TextInput,
            //         name: 'Value',
            //         label: 'Source',
            //         value: "-",
            //         columnSize: 12,
            //         disabled: true
            //     },
            // ]
            // below for v2.5, above for v2.5.1
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: 'Remarks',
                    label: 'SA_OBSERVATION',
                    value: '-',
                    columnSize: 12
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'Value',
                    label: 'Source',
                    value: "-",
                    columnSize: 12,
                    valueGetter: function (state, field) {
                        var value = state === null || state === void 0 ? void 0 : state[this.name];
                        return value === "1" ? "Customer Voice" : value === "2" ? "Road Test" : "";
                    }
                }]
        }];
    var detailsTab = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            alignItems: 'center',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    value: 'Job items',
                    fontWeight: 'strong',
                    fontSize: 'xl',
                    columnSize: true
                }, {
                    type: FormItemTypes.IconButton,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(Close, null),
                    columnSize: 0,
                    onClick: function (e) {
                        onClose(e.currentTarget.id === 'Confirm');
                    }
                }]
        }, {
            type: FormItemTypes.Divider,
            name: '',
            columnSize: 12,
            variant: 'fullWidth',
            sx: {
                mx: -2
            }
        },
        // hidden only UAT v2.5
        // {
        //     type: FormItemTypes.ContainerItem,
        //     name: '',
        //     elements: [
        //         {
        //             type: FormItemTypes.SearchSelect,
        //             name: 'job items',
        //             multiple: true,
        //             apiKey: 'complaintTypeGetComplaints',
        //             getListData: complaintTypeGetComplaintAPICall,
        //             renderTags: () => null,
        //             clearText: 'Clear Selected ',
        //             columnSize: true,
        //             placeholder: 'Search complaint',
        //             displayExpr: 'ComplaintName',
        //             valueExpr: 'id',
        //             setFormState: (state, value) => value?.length ? { CustomerComplaintsList: value } : {},
        //             valueGetter: (state) => state.CustomerComplaintsList,
        //         },
        //         {
        //             type: FormItemTypes.Button,
        //             name: 'More',
        //             children: <MoreVert />,
        //             size: 'small',
        //             variant: 'outlined',
        //             color: 'secondary',
        //             sx: { p: '7px' },
        //             columnSize: 0,
        //             setFormState: async (state, e) => {
        //                 const action = await dispatch(showSurface({
        //                     type: 'Menu',
        //                     containerProps: { anchorEl: e.target.parentElement },
        //                     Component: ActionMenuList,
        //                     componentProps: {
        //                         items: [
        //                             {
        //                                 id: 'delete',
        //                                 children: [<Delete color='secondary' fontSize="small" />, "Delete"]
        //                             },
        //                         ]
        //                     },
        //                 }));
        //                 let CustomerComplaintsList = state?.CustomerComplaintsList
        //                 if (action?.payload === 'delete') {
        //                     CustomerComplaintsList = CustomerComplaintsList?.filter((p: ResponseObject) => !p.Selected)
        //                 }
        //                 return {
        //                     CustomerComplaintsList
        //                 }
        //             }
        //         },
        //     ],
        //     xs: 12,
        //     sm: 8,
        //     md: 6,
        //     spacing: 1
        // },
        {
            type: FormItemTypes.List,
            name: 'CustomerComplaintsList',
            value: null,
            columnSize: 12,
            disableCheckboxSelection: true,
            disableBorder: true,
            variant: 'comfortable',
            columns: [{
                    field: 'ComplaintName',
                    flex: 1,
                    renderCell: function (_ref2) {
                        var value = _ref2.value;
                        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            color: "text.secondary",
                            sx: {
                                wordWrap: 'break-word',
                                overflowWrap: 'break-word',
                                whiteSpace: 'normal',
                                overflow: 'hidden',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical'
                            }
                        }, "Customer complaints :"), /*#__PURE__*/ React.createElement(Typography, {
                            fontWeight: 'medium'
                        }, value));
                    }
                }],
            elements: elements,
            disabled: true // for v2.5
        }, {
            type: FormItemTypes.Divider,
            name: '',
            columnSize: 12,
            variant: 'fullWidth',
            sx: {
                mx: -2
            }
        }
        // only UAT v2.5
        // {
        //     type: FormItemTypes.Button,
        //     name: 'job-item-save-btn',
        //     variant: 'contained',
        //     children: 'Save',
        //     columnSize: 12,
        //     fullWidth: true,
        //     onClick: () => 'submit'
        // },
        // {
        //     type: FormItemTypes.Button,
        //     name: 'job-item-cancel-btn',
        //     variant: 'outlined',
        //     children: 'Cancel',
        //     columnSize: 12,
        //     fullWidth: true,
        //     onClick: () => onClose()
        // }
    ];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: detailsTab,
        mode: "edit",
        gridSpacing: 0,
        gridProps: {
            gap: 2,
            p: 2
        },
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ({
                        data: {
                            CustomerComplaintsList: data
                        },
                        success: true
                    })];
            });
        }); },
        updateFormAPI: function (_ref3) { return __awaiter(void 0, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                request = _ref3.request;
                onClose(request === null || request === void 0 ? void 0 : request.CustomerComplaintsList);
                return [2 /*return*/, {
                        success: true
                    }];
            });
        }); }
    });
};
export default ViewJobItems;
